import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function Deposit() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [paying, setPaying] = useState(false);
  const pay = async () => {
    setPaying(true);
    try {
      const { data } = await api.post("/payments/deposit", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    }
    catch { toast.error("Could not start payment"); setPaying(false); }
  };
  return (
    <div className="mx-auto max-w-lg px-4 py-12 sm:px-6" data-testid="deposit-page">
      <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary"><ShieldCheck className="h-7 w-7" /></div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Security Deposit</h1>
        <p className="mt-3 text-sm text-slate-600">Before your listing goes live, SellStuff requires a refundable security deposit of AED 99. This deposit is held while you have active listings and covers any return costs if a buyer raises a valid concern. Your deposit will be fully refunded when you remove all your listings and request a release.</p>
        <Button data-testid="pay-deposit-btn" disabled={paying} onClick={pay} className="mt-6 w-full rounded-full bg-primary py-6 text-base font-semibold hover:bg-primary/90">{paying ? "Processing…" : "Pay AED 99 Security Deposit"}</Button>
      </div>
    </div>
  );
}
